import useLocalStorage from '@/hooks/useLocalStorage';
import { receivingType } from '@/types/checkout';
import { getPrice } from '@/utils/getPrice';
import { FormattedMessage } from 'react-intl';

interface IProps {
  totalDiscountPrice?: number; //(총 할인 금액)
  offerTotal?: number; //(주문 총액)
  totalPayment?: number; //(실 결제 금액)
  discountShippingFee?: number; //배송 할인 비
  shippingFee?: number; //배송비
  receivingMethod: receivingType;
}

export default function CartResultSection({
  totalDiscountPrice = 0,
  shippingFee = 0,
  offerTotal,
  totalPayment,
  discountShippingFee = 0,
  receivingMethod
}: IProps) {
  const [currency] = useLocalStorage('currency', null);
  // 4가지 케이스
  // 1, 픽업일때
  // 2. 국내배송일때
  // 3. 해외배송인데 배송비있을때
  // 4. 해외배송인데 배송비없을때

  return (
    <div className="w-full h-full py-4 px-[30px] bg-[#f5f5f5] flex flex-col gap-1">
      {receivingMethod !== 'pick_up' && (
        <div className="w-full flex flex-row justify-between items-center">
          <span className="text-[16px] leading-6 font-semibold text-[#262626]">
            <FormattedMessage id="price" defaultMessage="Price" />:
          </span>
          <span className="text-[16px] leading-6 font-semibold text-[#262626]">{`${getPrice(
            offerTotal?.toString() ?? '0',
            currency
          )}`}</span>
        </div>
      )}
      {totalDiscountPrice > 0 && (
        <div className="w-full flex flex-row justify-between items-center">
          <span className="text-[16px] leading-6 font-semibold text-[#262626]">
            <FormattedMessage id="discount" defaultMessage="Discount" />:
          </span>
          <span className="text-[16px] leading-6 font-semibold text-[#E52E2E]">{`- ${getPrice(
            totalDiscountPrice.toString(),
            currency
          )}`}</span>
        </div>
      )}
      {receivingMethod !== 'pick_up' && (
        <div className="w-full flex flex-row justify-between items-center">
          <span className="text-[16px] leading-6 font-semibold text-[#262626]">
            <FormattedMessage id="delivery_fee" defaultMessage="Delivery fee" /> :
          </span>
          <div>
            {discountShippingFee > 0 && (
              <span className="text-[16px] leading-6 font-semibold text-[#999] line-through">{`${getPrice(
                discountShippingFee.toString(),
                currency
              )}`}</span>
            )}
            <span className="text-[16px] leading-6 font-semibold text-[#262626]">{` ${getPrice(
              shippingFee.toString(),
              currency
            )}`}</span>
          </div>
        </div>
      )}

      <div className="w-full flex flex-row justify-between items-center">
        <span className="text-[20px] leading-7 font-bold">
          <FormattedMessage id="order_cart_total" defaultMessage="Order Total :" />
        </span>
        <span className="text-[20px] leading-7 font-bold">{`${getPrice(totalPayment?.toString() ?? '0', currency)}`}</span>
      </div>
    </div>
  );
}
